export default function getMaskValue(valor) {
  return valor.replace('R$ ', '').replace('.', '').replace(',', '.');
}
